import { render } from "./ServiceSlider.vue?vue&type=template&id=1f630156&scoped=true"
import script from "./ServiceSlider.vue?vue&type=script&lang=js"
export * from "./ServiceSlider.vue?vue&type=script&lang=js"

import "./ServiceSlider.vue?vue&type=style&index=0&id=1f630156&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f630156"]])

export default __exports__